const TextInputLength = {
  ZipMin: 5,
  ZipMax: 5,
};

export default TextInputLength;
